import { jsx as a, jsxs as L } from "react/jsx-runtime";
import { memo as x, useMemo as h, useCallback as T, useEffect as D } from "react";
import { Row as w, Col as N } from "antd";
import { u as E } from "./styled-components.browser.esm-BFmoFexH.js";
import { l as R } from "./lodash-DeBCDn4U.js";
import { notEmpty as W } from "@biron-data/react-components";
import { useEventResolver as _ } from "@biron-data/react-contexts";
import { useDimensionOptions as k } from "./hooks/useDimensionOptions.js";
import B from "./selector/filters/FilterPopover.js";
import I from "./selector/comps/BoxesWrapper.js";
import { _ as r, L as o, K as M } from "./dummyModel-DGc8qBEQ.js";
const O = (e) => {
  switch (e.predicate.operator) {
    case r.Match:
      return {
        type: o.dimension,
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case r.Like:
      return {
        type: o.dimension,
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case r.IN:
      return {
        type: o.dimension,
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case r.EQ:
    case r.GTE:
    case r.GT:
    case r.LT:
    case r.LTE:
      return {
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        type: o.dimension,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case r.BETWEEN:
      return {
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        type: o.dimension,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    default:
      return e.predicate;
  }
}, Z = () => ({
  operator: r.GT,
  value: {
    "@type": o.SCALAR,
    value: void 0
  },
  negate: !1
}), $ = () => ({
  operator: r.IN,
  value: {
    "@type": o.VALUE_LIST,
    values: []
  },
  negate: !1
}), C = x(function({
  value: s = [],
  availableDimensions: d,
  getPopupContainer: f,
  onChange: i,
  span: V = 14,
  GACategory: l,
  loadDictionaryEntries: b,
  consolidateInPlace: u = !1,
  isEditable: v = !0
}) {
  const y = _(), p = h(
    () => d.filter((t) => !t.asSimple),
    [d]
  ), c = T((t) => {
    const n = t.map((m) => O(m)).filter(W);
    return u ? i == null ? void 0 : i(M(n, p)) : i == null ? void 0 : i(n);
  }, [p, u, i]);
  D(() => {
    const t = s.filter((n) => d.find((m) => m.code === n.reference.code));
    R.isEqual(t, s) || c(t);
  }, [d, c, s]);
  const S = k(p), F = T((t) => {
    y.capture({
      category: l,
      action: "add_dimension_filter"
    }), c(t);
  }, [l, y, c]);
  return /* @__PURE__ */ a("div", { className: "filter-selector", children: /* @__PURE__ */ a(w, { children: /* @__PURE__ */ L(N, { span: V, children: [
    /* @__PURE__ */ a(j, { filters: s, seeDescription: !0, layout: "column", onFiltersChange: c, numberOfFilterPerLine: 1, bordered: !0, getPopupContainer: f, GACategory: l, $nbfilters: s.length, loadDictionaryEntries: b, isEditable: v }),
    /* @__PURE__ */ a(z, { children: /* @__PURE__ */ a(B, { isSimpleInput: !0, filters: s, getPopupContainer: f, getOptions: S, onTemporaryFiltersChange: F, colorized: !0, allowMultipleSelection: !1, getDefaultValue: $ }) })
  ] }) }) });
}), j = E(I)`
    ${({ $nbfilters: e }) => e > 0 ? "margin-bottom: 5px;" : ""}
`, z = E.div`

    &&& .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
        background-color: white;
        border-color: var(--border-color-input) !important;
    }
`;
export {
  C as D,
  Z as r
};
//# sourceMappingURL=DimensionFilterSelector-C9uyeZC8.js.map
